import {createContext} from "react";

import type {ActionBubble} from "@khan/guide-types";

export interface NotificationActionBubblesState {
    /**
     * The actions that will be displayed to the user.
     */
    actions: ReadonlyArray<ActionBubble>;
    /**
     * A flag indicating whether all actions are visible to the user.
     */
    allActionsDisplayed: boolean;
    /**
     * The actions that are currently displayed.
     */
    displayedActions: ReadonlyArray<ActionBubble>;
    /**
     * Whether the notification action bubbles are collapsed.
     */
    isCollapsed: boolean;
}

export interface NotificationActionBubblesContextState {
    state: NotificationActionBubblesState;
    handleCollapse: () => void;
    handleDismiss: () => void;
    handleExpand: () => void;
    handleDidShow: () => void;
}

const defaultContext = {
    state: {
        actions: [],
        allActionsDisplayed: true,
        displayedActions: [],
        isCollapsed: false,
    },
    handleCollapse: () => {},
    handleDismiss: () => {},
    handleExpand: () => {},
    handleDidShow: () => {},
};

// Create a context
export const NotificationActionBubblesContext =
    createContext<NotificationActionBubblesContextState>(defaultContext);
